import { useSubscription } from '@apollo/client';
import { SUBSCRIPTION } from '../gql';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../redux/hooks';

const NotificationSubscription = (): JSX.Element => {
  const [actionUserId, setActionUserId] = useState<string>('');
  const { profileData } = useAppSelector((state) => state.profileData);
  const {
    data: subscriptions,
    loading,
    error
  } = useSubscription(SUBSCRIPTION, {
    variables: {
      actionUserId
    }
  });

  useEffect(() => {
    if (profileData) {
      if (profileData.memberId) {
        setActionUserId(profileData.memberId);
      }
    }
  }, [profileData]);

  if (loading) {
    // eslint-disable-next-line no-console
    console.log('Subscription loading...');
  } else if (error) {
    console.error('Subscription error:', error);
  } else {
    // eslint-disable-next-line no-console
    console.log('New project created:', subscriptions.realTimeUpdate);
  }

  return <></>;
};

export default NotificationSubscription;
